/* RESPONSIBLE TEAM: team-proactive-support */
import generateViewModeConfig from 'embercom/objects/content-editor/configuration-generators/control-group/view-mode-generator';

export default function generateEditorConfig(options) {
  return {
    viewMode: generateViewModeConfig(options),
  };
}
